import React from 'react';
import themeDark from "../../../shared/themeDark";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { MuiThemeProvider } from "@material-ui/core/styles";
import YellowBox from './YellowBox';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface ChooseDialogPage1Props {
    setPage: any,
    goToAmbulanceDialog: any,
    cancelEndCallout: any,
    setCalloutReasonValuesObj: any
};

const useStyles = makeStyles(() => ({
    typoHead: {
        fontSize: 46,
        fontWeight: 700,
        color: "#FFF",
    },
    icon: {
        color: 'white'
    },
    topContainer:{
        display: 'flex',
        justifyContent:'flex-end'
    },
    iconButton:{
        padding:0
    }
}));

const ChooseDialogPage1: React.FC<ChooseDialogPage1Props> = ({
    setPage,
    goToAmbulanceDialog,
    cancelEndCallout,
    setCalloutReasonValuesObj
}) => {
    const classes = useStyles();

    const onClick = (goToAmbulance: boolean) =>{
        setCalloutReasonValuesObj(null);
        if(goToAmbulance){
            goToAmbulanceDialog();
        }else{
            setPage(2);
        }
    }

    return (
        <MuiThemeProvider theme={themeDark}>
            <Paper
                style={{
                    height: "100vh",
                    overflowY: "scroll",
                    padding: 74,
                    borderRadius: 0,
                }}
            >
                <div className={classes.topContainer}>
                    <span>
                        <IconButton
                            aria-label="close"
                            className={classes.iconButton}
                            onClick={cancelEndCallout}>
                            <CloseIcon className={classes.icon} />
                        </IconButton>
                    </span>
                </div>
                <Typography variant="body1" component="div" className={classes.typoHead}>
                    Did this callout take longer than expected?
                </Typography>
                <div style={{ display: "flex", marginTop: 24 }}>
                    <YellowBox style={{ padding: "2px 0px", marginRight: 24 }} title="No" onClick={() => onClick(true)} />
                    <YellowBox style={{ padding: "2px 0px" }} title="Yes" onClick={() => onClick(false)} />
                </div>
            </Paper>
        </MuiThemeProvider>
    );
}

export default ChooseDialogPage1;